import { EntityMetadata } from '@ngrx/data';

export interface MissedAppointmentsDashboardQueryFilter {
    jobIds?: Array<number>;
}
/**
 * Meta data for the entity to be included in the EntityMetadataMap registered in the EntityModule.
 */
export const missedAppointmentsDashboardEntityMetadata: EntityMetadata<any> = {
    entityName: 'MissedAppointmentsDashboard',
    selectId: jobSelectId, // .id is used if doing optimistic update
    additionalCollectionState: {
        refreshing: false,
        queryFilter: {
            jobIds: []
        },
        totalMissedCount: 0
    }
};

// tslint:disable-next-line:only-arrow-functions typedef
export function jobSelectId<T extends { id: any }>(missed: any) {
    return  missed === undefined ? undefined : missed.id || missed.jobId;  // .id is used if doing optimistic update
}

